window.nacl = require('tweetnacl');
window.msgpack = require('msgpack-lite');

const saltyrtcClient = require('@saltyrtc/client/dist/saltyrtc-client.es2015');
const chunkedDc = require('@saltyrtc/chunked-dc/dist/chunked-dc.es2015');
window.saltyrtcClient = saltyrtcClient;
window.chunkedDc = chunkedDc;
const saltyrtcTaskWebrtc = require('@saltyrtc/task-webrtc/dist/saltyrtc-task-webrtc.es2015');

export {
    saltyrtcClient,
    saltyrtcTaskWebrtc,
    chunkedDc
}
